<template lang="pug">
  #admin-super-member-center
    WtTile(ancestor)
      //- WtTile(vertical :col="7")
      //-   WtTile(parent)
      //-     WtTile(
      //-       child
      //-       :col="12"
      //-       :is-loading="templatesLoading"
      //-     )
      //-       EmailTemplatesTable(
      //-         :templates-data="templates"
      //-         @save-template="onSaveTemplate"
      //-         @update-template="onUpdateTemplate"
      //-         @delete-template="onDeleteTemplate"
      //-       )

      WtTile(vertical)
        WtTile(parent)
          WtTile(child :col="12")
            | Nothing to see here.

      WtTile(vertical v-if="$auth.user().email.includes('michel') || $auth.user().email.includes('elomonaco')")
        WtTile(parent)
          WtTile(child :col="12")
            button.button(@click="cacheBuster") Cache Buster
</template>

<script>
import { mapActions } from "vuex";
import WtTile from "@@/WtTile/WtTile";
import EmailTemplatesTable from "@@/MemberCenterAdminSuper/EmailTemplatesTable";

export default {
  name: "AdminSuperMemberCenter",

  components: { WtTile, EmailTemplatesTable },

  data() {
    return {
      templates: [],
      templatesLoading: false
    };
  },

  // mounted() {
  //   this.fetchEmailTemplates();
  // },

  methods: {
    ...mapActions("emailTemplates", [
      "fetchTemplates",
      "storeTemplate",
      "deleteTemplate",
      "updateTemplate"
    ]),

    async fetchEmailTemplates() {
      this.templatesLoading = true;
      this.templates = await this.fetchTemplates();
      this.templatesLoading = false;
    },

    onSaveTemplate(payload) {
      this.storeTemplate(payload).then(response => {
        if (response && response.data.success) {
          this.fetchEmailTemplates();
        }
      });
    },

    onDeleteTemplate(id) {
      this.deleteTemplate(id).then(response => {
        if (response && response.data.success) {
          this.fetchEmailTemplates();
        }
      });
    },

    onUpdateTemplate(payload) {
      this.updateTemplate(payload).then(response => {
        if (response && response.data.success) {
          this.fetchEmailTemplates();
        }
      });
    },

    cacheBuster() {
      this.$buefy.dialog.confirm({
        title: "for emergency use only",
        confirmText: "it's me mario",
        type: "is-danger",
        hasIcon: true,
        message: "are you mario?",
        onConfirm: async () => {
          this.axios
            .get(`cache-buster`)
            .then(response => {
              if (response && response.data.success) {
                this.$buefy.toast.open("BUSTED!");
              }
              console.log("response: ", response);
            })
            .catch(error => {
              this.$buefy.toast.open("try again...");
              console.log("error: ", error);
            });
        }
      });
    }
  }
};
</script>

<style lang="sass" scoped></style>
